export default "__VITE_ASSET__B9_gC4lO__"